<template>
  <div>
    <dynamic-market
      v-if="config"
      :config="config"
    />
    <div
      v-else
      class="market-entry"
      role="status"
    >
      <p>{{ loading ? $t('Loading') : unavailable ? unavailableText : $t('An error occurred during the operation') }}</p>
      <button
        v-if="!loading"
        type="button"
        class="btn btn-primary"
        @click="load"
      >
        {{ $t('Try again') }}
      </button>
      <router-link :to="{ name: 'market' }">
        {{ $t('Go market') }}
      </router-link>
    </div>
  </div>
</template>

<script>
// Same authenticated client/router dependency as the existing market views.
// eslint-disable-next-line import/no-cycle
import market from '@/services/DynamicMarketService'
import DynamicMarket from './DynamicMarket.vue'

export default {
  components: { DynamicMarket },
  data: () => ({ config: null, unavailable: false, loading: true }),
  computed: {
    unavailableText() {
      const text = {
        en: 'Dynamic market is currently unavailable.', tr: 'Dinamik market şu anda kullanılamıyor.', de: 'Der dynamische Markt ist derzeit nicht verfügbar.', es: 'El mercado dinámico no está disponible actualmente.', fr: 'Le marché dynamique est actuellement indisponible.', pt: 'O mercado dinâmico está indisponível.', ru: 'Динамический маркет сейчас недоступен.', ua: 'Динамічний маркет наразі недоступний.', ar: 'المتجر الديناميكي غير متاح حاليًا.',
      }
      return text[this.$i18n.locale] || text.en
    },
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      this.unavailable = false
      try {
        this.config = await market.config()
      } catch (error) {
        const payload = error.response && error.response.data
        const message = payload && payload.header && payload.header.error && payload.header.error.message
        // This page never replaces or redirects the original /market.
        this.unavailable = message === 'dynamic_market_unavailable' || error.message === 'dynamic_market_unavailable'
      } finally { this.loading = false }
    },
  },
}
</script>

<style scoped>
.market-entry { min-height: 45vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1rem; }
</style>
